import { useContext } from 'react';
import { CreateGroupChatContext } from '~/pages/CreateGroupChat';
import * as S from '~/pages/CreateGroupChat/index.styled';
import { FlexStack } from '~/components/atomic';
import { useGetMyFavoriteListQuery } from '~/features/user';
import { useUserStore } from '~/store';
import SelectAiCard from '../SelectAiCard/SelectAiCard';

export interface isMaxSelectedProps {
  isMaxSelected?: boolean;
}

export default function MyFavoriteCharacters({
  isMaxSelected,
}: isMaxSelectedProps) {
  const { data } = useGetMyFavoriteListQuery();

  const {
    selectedAiCharacter,
    handleDeleteCharacterClick,
    handleAddCharacterClick,
  } = useContext(CreateGroupChatContext);

  return (
    <FlexStack>
      <S.SectionTitle>My favorite</S.SectionTitle>

      {data.length === 0 && (
        <S.NoItemMessage>
          Add favorite characters in home section
        </S.NoItemMessage>
      )}

      {data.map((el) => {
        const isSelected = selectedAiCharacter.some(
          (s) => s.character_id === el.character_id,
        );

        return (
          <SelectAiCard
            key={el.character_id}
            name={el.character_name}
            description={el.character_desc}
            like={el.liked_count}
            isSelected={isSelected}
            imageUrl={el.character_image}
            createUsername={el.create_username}
            onClick={() =>
              isSelected
                ? handleDeleteCharacterClick(el)
                : handleAddCharacterClick(el)
            }
            isMaxSelected={isMaxSelected}
          />
        );
      })}
    </FlexStack>
  );
}
